import {
  type AutomationTemplateId,
  AutomationTemplateIds,
} from "@repo/app-types/entities/automation";
import { SimpleModal, SimpleModalVariant } from "@repo/ui/Modal/modal";
import type { FC } from "react";

const deleteConsequencesByTemplate: Record<AutomationTemplateId, string> = {
  [AutomationTemplateIds.TEAMMATE_COACHING]:
    "Future coaching goal notifications will stop. Any coaching focus notes in this agent will no longer shape coaching goals in teammate profiles.",
  [AutomationTemplateIds.PLAYBOOK_SCORE_MOVEMENT]:
    "Future notifications from this agent will stop.",
  [AutomationTemplateIds.LEAD_BURNING]:
    "Future] notifications from this agent will stop.",
  [AutomationTemplateIds.CUSTOMER_PRAISE_DIGEST]:
    "Future notifications from this agent will stop.",
  [AutomationTemplateIds.PERFECT_CALLS]:
    "Future notifications from this agent will stop.",
  [AutomationTemplateIds.CUSTOM]:
    "Future notifications from this agent will stop.",
};

export interface DeleteAutomationModalProps {
  isOpen: boolean;
  templateId: AutomationTemplateId;
  onCancel: () => void;
  onDelete: () => void;
}

export const DeleteAutomationModal: FC<DeleteAutomationModalProps> = (
  props,
) => {
  const { isOpen, templateId, onCancel, onDelete } = props;
  return (
    <SimpleModal
      isOpen={isOpen}
      onCancel={onCancel}
      variant={SimpleModalVariant.Warning}
      title="Delete agent?"
      subtitle={deleteConsequencesByTemplate[templateId]}
      confirmButtonText="Delete agent"
      onConfirm={onDelete}
    />
  );
};
